import { createContext, useContext, useMemo } from "react";
import useLocalStorage from '../../hooks/local-storage';
import useWindowSize from '../../hooks/window-size';
// import userStore from "../common/userStore";


const TipsEditorContext = createContext({})

const useTipsEditor = () => {
  return useContext(TipsEditorContext)
}

const TipsProvider = ({children, requiredTips}) => {
  const { width } = useWindowSize()
  const [tipsEditor, setTipsEditor] = useLocalStorage('tipsEditor', '0')
  const canShowTips = useMemo(() => {
    return requiredTips && tipsEditor !== '1'
  }, [width, tipsEditor, requiredTips])
  return <TipsEditorContext.Provider value={{tipsEditor, setTipsEditor, canShowTips}}>
    {children}
  </TipsEditorContext.Provider>
}

export {useTipsEditor, TipsProvider}